<template>
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-long-circle-up">
    <g id="Group 23">
    <path class="color" id="vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 1.01406e-06 19 2.26498e-06C8.50659 3.51589e-06 2.98809e-07 8.50659 1.54972e-06 19C2.80063e-06 29.4934 8.50659 38 19 38Z" :fill="secondaryColor" :style="{opacity: opacity}"/>
    <path id="vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" :fill="color" d="M26.5851 18.0209C27.1383 18.5617 27.1383 19.4383 26.5851 19.9791L21.8628 24.5945C21.3096 25.1352 20.4126 25.1352 19.8594 24.5945C19.3061 24.0537 19.3061 23.177 19.8594 22.6363L22.1632 20.3846L11.4167 20.3846C10.6343 20.3846 10 19.7647 10 19C10 18.2353 10.6343 17.6154 11.4167 17.6154L22.1632 17.6154L19.8594 15.3637C19.3061 14.823 19.3061 13.9463 19.8594 13.4055C20.4126 12.8648 21.3096 12.8648 21.8628 13.4055L26.5851 18.0209Z"/>
    </g>
    </g>
    </svg>
</template>

<script>
export default {
  name: 'Line2',
  props: {
    color: {
      type: String,
      required: true,
    },
    secondaryColor: {
      type: String,
      required: true,
    },
    opacity: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="css" scoped>
</style>